import axios from 'axios'
const state = {
    loading: false,
    products: [],
    product: null,
    page: 1,
    size: 12,
    hasMore: true,
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
};
const getters = {
    getLoadingStatus(state) {
        return state.loading;
    },
    getProduct(state) {
        return state.product
    },
    getProducts(state) {
        return state.products
    },
    getTableOptions(state) {
        return state.tableOptions
    },
    getHasMore(state) {
    return state.hasMore;
},

};

const mutations = {
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setProduct(state, product) {
        state.product = product;
    },
    setProducts(state, products) {
        state.products = products
    },
     appendProducts(state, products) {
        state.products = [...state.products, ...products];
    },
    setPage(state, page) {
        state.page = page;
    },
    setHasMore(state, status) {
        state.hasMore = status;
    },
    resetProducts(state) {
        state.products = [];
        state.page = 1;
        state.hasMore = true;
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    },
};

const actions = {
  
    async fetchB2cProducts({ commit, state }, queryParams = {}) {
        if (state.loading || !state.hasMore) return;
        try {
            commit('setLoadingStatus', true);
            const response = await axios.get("/catalog/product", {
                params: {
                    page: state.page,
                    size: state.size,
                    ...queryParams
                }
            });
            const { data, meta } = response.data;
            console.log("Fetching page:", state.page);
            if (state.page === 1) {
                commit('setProducts', data);
            } else {
                commit('appendProducts', data);
            }
            if (meta.current_page < meta.last_page) {
                commit('setPage', state.page + 1);
            } else {
                commit('setHasMore', false);
            }
        } catch (err) {
            console.log(err);
        } finally {
            commit('setLoadingStatus', false);
        }
    },



    async fetchProducts({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/catalog/product", {
                params,
            });
            commit('setProducts', response.data.data)
            // commit('setTableData', {
            //     tableHeaders: [
            //         "name",
            //         "Code",
            //         "Exchange",
            //         "settings",
            //     ],
            //     tableData: response.data.data,
            //     accessTableData: [
            //         ["name"],
            //         ["code"],
            //         ["exchange"],
            //     ],
            //     tableMeta: {
            //         total: response.data.meta.total,
            //         page: response.data.meta.current_page,
            //     },
            // })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchProduct({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/catalog/product/${id}`);
            commit('setProduct', response.data.data);
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    
}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}